/**
 * Сохранение в редакторе эфира легло на диск, а заявку правки сервер эфира не принял (ответ `stream_fixes[i].error`:
 * «правка сохранена, но в эфир не отправлена: …» — translate-python `post_fixes`). Прежде редактор этот отказ не
 * показывал: сохранение выглядело успешным, в эфир правка не уходила, и переводчик об этом не знал (проба P50m10d,
 * 03.11: 422 site_server на растянутую длину неозвученной реплики отверг и места других реплик того же сохранения).
 * Теперь — тост с причиной словами сервера и запись в консоль (по ней отказ видят и агенты проверки).
 */
import type { ToastArgs } from "../NotificationProvider/NotificationProvider";

export interface SaveFixRefusal {
    message: string;
    description: string;
}

const clip = (text: string, max = 400): string => {
    const one = text.replace(/\s+/g, " ").trim();
    return one.length > max ? `${one.slice(0, max - 1)}…` : one;
};

/** Отказы заявок правки в ответе сохранения; null — отказов нет (или ответ без `stream_fixes`). */
export const saveFixRefusal = (data: unknown, en = false): SaveFixRefusal | null => {
    const fixes = data && typeof data === "object" ? (data as Record<string, any>).stream_fixes : null;
    if (!Array.isArray(fixes)) return null;
    const errors: string[] = [];
    for (const fix of fixes) {
        if (!fix || typeof fix.error !== "string" || !fix.error.trim()) continue;
        const line = clip(fix.error);
        if (!errors.includes(line)) errors.push(line);
    }
    if (!errors.length) return null;
    return {
        message: en
            ? "Saved, but NOT sent on air"
            : "Сохранено, но в эфир не отправлено",
        description: en
            ? `${errors.join("; ")}. The edit is on disk but did not go on air — change the cue and save again.`
            : `${errors.join("; ")}. Правка лежит на диске, но в эфир не ушла — поправьте реплику и сохраните снова.`,
    };
};

interface Notifier {
    openToast?: (toast: ToastArgs) => void;
    openErrorNotification?: (text: string) => void;
}

/** Показать отказ тостом (пока не закроют) и записать в консоль. -> показан ли. */
export const showSaveFixRefusal = (notify: Notifier | null | undefined, data: unknown, en = false): boolean => {
    const refusal = saveFixRefusal(data, en);
    if (!refusal) return false;
    console.warn("[FLUSH] stream fix refused", refusal);
    if (notify?.openToast) {
        notify.openToast({ type: "warning", ...refusal, duration: 0, key: "save-fix-refused" });
    } else {
        notify?.openErrorNotification?.(`${refusal.message}: ${refusal.description}`);
    }
    return true;
};
